import { useRef as t, useEffect as f } from "react";
const u = (e) => {
  const s = t(e);
  return s.current = e, f(() => {
    s.current = e;
  }, [e]), s;
};
export {
  u
};
//# sourceMappingURL=useLatest-hmRS46UF.js.map
